
import { Component, Vue, Prop } from "vue-property-decorator";
import ImageBox from "@/components/Base/ImageBox.vue";
import ImageSelector from "@/components/Base/ImageSelector.vue";
import { GAMETYPE_ID, InvItem, Season } from "@/models/GameType";
import StringHelper from "@/utils/StringHelper";
import { cloneDeep } from "lodash";

@Component({
  components: { ImageSelector, ImageBox },
})
class AddInventory extends Vue {
  @Prop({ default: null }) readonly seasonData!: Season;
  displayName = "";
  description = "";
  shown = true;
  quant = 1;
  imagePath = "";
  seasonDataObject = {} as Season;
  errorMessage = "";
  showImageSelectorBool = false;

  created(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  updated(): void {
    this.seasonDataObject = cloneDeep(this.seasonData);
  }

  get getImage(): string {
    return this.imagePath;
  }

  get getGameTypeID(): GAMETYPE_ID {
    if (this.$store.state.gameStore.gameType.length > 0)
      return this.$store.state.gameStore.gameTypeSelected;
    return GAMETYPE_ID.MANHUNT;
  }

  get getImagePath(): string {
    return (
      "/gametype/" +
      this.getGameTypeID +
      "/seasons/" +
      this.seasonData.slug +
      "/img/inventory/"
    );
  }
  get getSlugifyName(): string {
    return StringHelper.Slugify(this.displayName);
  }

  showImageSelector(): void {
    this.showImageSelectorBool = true;
  }
  handleCloseButtonPress(): void {
    this.showImageSelectorBool = false;
  }

  cancel(): void {
    this.$bvModal.hide("team-modal-add-inventory");
  }
  saveInv(): void {
    if (this.displayName.length > 0 && /[a-z]/i.test(this.displayName)) {
      var data = {
        slug: this.getSlugifyName,
        name: { en: this.displayName },
        desc: { en: this.description },
        img: this.imagePath,
        quant: this.quant,
        shown: this.shown,
      } as InvItem;
      if (this.getGameTypeID === GAMETYPE_ID.QUEST) {
        data.type = "default";
      }
      this.seasonDataObject.inv_items[data.slug] = data;
      this.seasonDataObject.fx[data.slug] = {
        desc:
          "Auto generated FX by inventory item " +
          data.slug +
          " . DO NOT DELETE",
        slug: data.slug,
      };
      this.$store.dispatch("gameStore/updateSeasonType", this.seasonDataObject);
      this.displayName = "";
      this.description = "";
      this.imagePath = "";
      this.quant = 0;
      this.shown = false;
      this.$bvModal.hide("team-modal-add-inventory");
    } else {
      this.$bvModal.show("modal-sm");
      this.errorMessage =
        "Please make sure the display name is not empty and contains at least one letter";
    }
  }
  returnImagePath(name: string): void {
    if (name.length > 0) {
      this.imagePath = this.getImagePath + "" + name;

      this.showImageSelectorBool = false;
    } else {
      this.imagePath = "";
    }
  }
}

export default AddInventory;
